<template>
    <div style="overflow: scroll;">

        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Bagger {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Bagger - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <!-- {{bagger}} -->
            <div v-if="customFormMode == 1">
                <base-input alternative="" label="Code" placeholder="" v-model="bagger.code" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="bagger.name" input-classes="form-control" required />
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="bagger.remark" />
                </base-input>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="bagger" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="bagger.code" input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="bagger.name" input-classes="form-control" required />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="bagger.remark" />
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="bagger" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
           

        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import DynamicForm from '../DynamicForm.vue'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            
            // Handling of metadata
            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Bagger?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
                const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
                if(accSystemModule != null){
                    if(accSystemModule.form_mode != undefined){
                        this.customFormMode = accSystemModule.form_mode
                    }
                    if(accSystemModule.customized_forms != undefined){
                        this.customForm = accSystemModule.customized_forms
                    }
                }
            }

            component_x = this
            if (component_x.profileId > 0) {
                var bagger_data = await HTTPRequest.getRequest(component_x.endPoint + 'baggers/' + component_x.profileId, null)
                if (bagger_data == undefined) {
                    component_x.$router.go()
                } else {
                    if (bagger_data["error"] == undefined) {
                        component_x.bagger = bagger_data
                        // component_x.profileData = bagger_data
                        component_x.inputName = bagger_data["name"]
                        component_x.inputCode = bagger_data["code"]
                        component_x.inputRemark = bagger_data["remark"]
                    } else {
                        component_x.errors = bagger_data["error"].split(",");
                    }
                }
            }

            this.dynamicFormKey++;
        },
        data: function () {
            return {
                inputName: '',
                inputCode: '',
                inputRemark: '',
                errors: [],
                // FOR META-DATA
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                bagger: {},
                formErrors: []
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bagger
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors

                if(this.customFormMode == 3) {
                    this.errors = errors
                }

                this.bagger = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },
            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.inputCode));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.bagger.code));
                this.errors.push(ValidateField.charMinAndMax('Code', this.bagger.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.bagger.name));
                // this.errors.push(ValidateField.alphanumericWithSpace('Name', this.bagger.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.bagger.name, 0, 50));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    this.bagger.name = this.bagger.name.trim()
                    if (this.bagger.code) this.bagger.code = this.bagger.code.trim()
                    this.bagger.status = 'A'
                    var baggerPayload = { bagger: this.bagger }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'baggers', null, baggerPayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    this.bagger.name = this.bagger.name.trim()
                    if (this.bagger.code) this.bagger.code = this.bagger.code.trim()
                    let status = (this.bagger.status == null) ?  "A" : this.bagger.status
                    this.bagger.status = status
                    // this.bagger.status = 'A'
                    var baggerPayload = { bagger: this.bagger }
                    // console.log("**************")
                    // console.log(baggerPayload)
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'baggers/' + this.profileId, null, baggerPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style>
</style>